import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import AntdButtonGroup from 'antd/es/button/button-group';
export const GroupSizeContext = React.createContext(undefined);
const ButtonGroup = (props) => {
    const { size, className, prefixCls: customizePrefixCls, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const customClassName = classNames({
        [`${prefixCls}-${size}`]: size === 'xs' || size === 'xl'
    }, className);
    // Resume the props if it's not for b-design.
    const customProps = otherProps;
    if (size !== 'xs' && size !== 'xl') {
        customProps.size = size;
    }
    return React.createElement(AntdButtonGroup, { className: customClassName, prefixCls: prefixCls, ...customProps });
};
// export default withConfigProvider(ButtonGroup);
export default ButtonGroup;
